import { ProjConstants } from 'src/app/utils/proj.constant';

export const ColdwaveMapConstants = {
  CommonLayers: [
    // {
    //   layerNameType: 'STATE',
    //   serviceType: 'VectorLayer',
    //   view: 'Both',
    //   type: 'Time',
    //   env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //   dataurl: 'heatWatches/getHeatWatchesData',
    //   hval: 'hwv',
    //   hcat: 'hwc'
    // },
    {
      layerNameType: 'STATE',
      serviceType: 'WmsLayer',
      view: 'Both',
      type: 'Base',
      env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      pane: 'popup',
      styles: 'INDIA_STATE_NAMES',
      minZoom: 5,
    },
    // {
    //     layerNameType : 'DISTRICT',
    //     serviceType : 'WmsLayer',
    //     view : 'Both',
    //     type : 'Base',
    //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //     pane : 'village',
    //     styles:'INDIA_DISTRICT_NAMES',
    //     minZoom:8,
    //     maxZoom:9
    //   },
      {
        layerNameType : 'DISTRICT',
        serviceType : 'VectorLayer',
        view : 'Both',
        type : 'Time',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        dataurl : 'heatWatches/getHeatWatchesData' ,
        hval :"cwv",
        hcat : "cwc",
        pane : 'popup'
      }
  ],
  Legend: {
    colorValues: [
      {
        backgroundColor: ProjConstants.COLD_WATCHES_LEGEND.normal,
        color: '#000000',
        text: 'Normal'
      },
      {
        backgroundColor: ProjConstants.COLD_WATCHES_LEGEND.cold_waves,
        color: '#000000',
        text: 'Cold Wave'
      },
      {
        backgroundColor: ProjConstants.COLD_WATCHES_LEGEND.severe_cold_waves,
        color: '#FFFFFF',
        text: 'Severe Cold Wave'
      }
    ],
  },
  legendData: {
    levels: [
      {
        color: ProjConstants.COLD_WATCHES_LEGEND.severe_cold_waves,
        name: 'Severe Cold Wave'
      },
      {
        color: ProjConstants.COLD_WATCHES_LEGEND.cold_waves,
        name: 'Cold Wave'
      },
      {
        color: ProjConstants.COLD_WATCHES_LEGEND.normal,
        name: 'Normal'
      }
    ]
  }
};
